import { httpClient } from './httpClient';

export interface SuggestedGuideline {
  id: string;
  reasons: string[];
}

export interface SuggestedGuidelinesResponse {
  suggestedGuidelineIds: string[];
  guidelines: SuggestedGuideline[];
}

interface SuggestedGuidelinesRequest {
  caseDescription: string;
  caseTypes: string[];
  instructionLetterSummary?: string;
}

export async function fetchSuggestedGuidelines(
  caseId: string,
  caseDescription: string,
  caseTypes: string[],
  instructionLetterSummary?: string,
): Promise<SuggestedGuidelinesResponse> {
  const body: SuggestedGuidelinesRequest = {
    caseDescription,
    caseTypes,
    instructionLetterSummary,
  };
  return httpClient.post<SuggestedGuidelinesResponse>(
    `/intelligence/cases/${caseId}/suggested-guidelines`,
    body,
  );
}
